import { store } from '@/store'

/**
 * Shared session check for the top-level gate screens (`beta-locked`,
 * `accept-terms`). They sit OUTSIDE the `_private` layout (so redirecting a
 * gated partner to them does not re-trigger the `_private` gate and loop), but
 * they are still session-only surfaces: an unauthenticated direct visit or hard
 * refresh has no token, so e.g. the Accept POST would 401 into a dead end.
 *
 * Resolves the session (initializing if needed) and returns whether the visitor
 * is authenticated. The route's `beforeLoad` throws the `/login` redirect when
 * this is false — the throw stays in the route file where `throw redirect(...)`
 * is the idiomatic TanStack pattern. One owner of "is there a session?" so the
 * two gate routes can't drift.
 */
export const isGateVisitorAuthenticated = async (): Promise<boolean> => {
  const state = store.getState()
  if (!state.isInitialized) {
    await state.initialize()
  }

  return store.getState().isAuthorized
}
